import { useUserStore } from "@/stores/user.store";
import { computed, toValue, type MaybeRefOrGetter } from "vue";

import { possibleUserColors, getNumberBasedOnId } from "@/utils/color";

export function useUserColor(id: MaybeRefOrGetter<string | undefined | null>) {
  const userStore = useUserStore();

  const color = computed(() => {
    const userId = toValue(id) || userStore.user?.id;

    if (!userId) return null;

    const idx = getNumberBasedOnId(userId);
    return possibleUserColors[idx];
  });

  return color;
}
